<template>
  <div class="div-wrapper">
    <div class="top-div d-flex justify-content-between align-items-start border-bottom pb-3">
      <div>
        <h5 class=" mb-2" style="color: #0055A6; font-weight: bolder;">{{ $t("globalPolicy") }}</h5>
        <div class="d-flex justify-content-between align-items-start">
          <p class="text-muted mb-2 col-10">
            {{ $t('tooltips.headers.globalPolicyHeader') }}
          </p>
        </div>
      </div>
      <div class="align-self-center">
        <button type="button" class="actions-btn" @click="menu.toggle($event)">
          <span class="label">{{ $t("actions2") }}</span>
          <span class="divider"></span>
          <i :class="['chevron', isMenuOpen ? 'pi pi-chevron-up' : 'pi pi-chevron-down']"></i>
        </button>
        <Menu ref="menu" :model="items" :popup="true" @show="isMenuOpen = true" @hide="isMenuOpen = false" />
      </div>
    </div>
    <TabView class="custom-tabs" v-model:activeIndex="activeTab">
      <TabPanel :header="$t('fileAccess')">
        <div class="d-flex justify-content-end gap-3 mb-3">
          <Button class="custom-icon-button" @click="showEdit(t('addRule'), FileAccessEditForm, 'fileAccess')">
            <i class="ag-icon ag-icon_add_icon"></i>
            <span class="label-text">{{ $t('addNewRule') }}</span>
          </Button>
        </div>
        <div class="table-border-div">
          <div class="input-class align-items-center gap-2 mb-3 px-2 ">
            <TabsFilter v-model:search="searchQuery" v-model:status="statusFilter" @clear="clearSearch" :totalRules="filteredFileAccessRows.length" />
          </div>
          <ag-card
            :module="{ ...fileAccessModule, component: { ...fileAccessModule.component, options: { ...fileAccessModule.component.options, rows: filteredFileAccessRows } } }"
            @edit="(rowData) => editFunction2(t('editRule'), FileAccessEditForm, 'fileAccess', rowData)"
            @deleteClick="(rowData) => deleteGlobalPolicy(rowData, 'fileAccess')"
            @copyClick="(rowData) => copyFunction(rowData, 'fileAccess')">

          </ag-card>
        </div>
      </TabPanel>
      <TabPanel :header="$t('registryAccess')">
        <div class="d-flex justify-content-end gap-3 mb-3">
          <Button class="custom-icon-button" @click="showEdit(t('addRule'), RegistryEditForm, 'registry')">
            <i class="ag-icon ag-icon_add_icon"></i>
            <span class="label-text">{{ $t('addNewRule') }}</span>
          </Button>
        </div>
        <div class="table-border-div">
          <div class="input-class align-items-center gap-2 mb-3 px-2 ">
            <TabsFilter v-model:search="searchQuery" v-model:status="statusFilter" @clear="clearSearch" :totalRules="filteredRegistryRows.length" />
          </div>
          <ag-card
            :module="{ ...registryModule, component: { ...registryModule.component, options: { ...registryModule.component.options, rows: filteredRegistryRows } } }"
            @edit="(rowData) => editFunction2(t('editRule'), RegistryEditForm, 'registry', rowData)"
            @deleteClick="(rowData) => deleteGlobalPolicy(rowData, 'registry')"
            @copyClick="(rowData) => copyFunction(rowData, 'registry')">
          </ag-card>
        </div>

      </TabPanel>
      <TabPanel :header="$t('codeLoad')">
        <div class="d-flex justify-content-end gap-3 mb-3">
          <Button class="custom-icon-button" @click="showEdit(t('addRule'), CodeLoadEditForm, 'codeLoad')">
            <i class="ag-icon ag-icon_add_icon"></i>
            <span class="label-text">{{ $t('addNewRule') }}</span>
          </Button>
        </div>
        <div class="table-border-div">
          <div class="input-class align-items-center gap-2 mb-3 px-2 ">
            <TabsFilter v-model:search="searchQuery" v-model:status="statusFilter" @clear="clearSearch" :totalRules="filteredCodeLoadRows.length" />
          </div>
          <ag-card
            :module="{ ...codeLoadModule, component: { ...codeLoadModule.component, options: { ...codeLoadModule.component.options, rows: filteredCodeLoadRows } } }"
            @edit="(rowData) => editFunction2(t('editRule'), CodeLoadEditForm, 'codeLoad', rowData)"
            @deleteClick="(rowData) => deleteGlobalPolicy(rowData, 'codeLoad')"
            @copyClick="(rowData) => copyFunction(rowData, 'codeLoad')">

          </ag-card>
        </div>

      </TabPanel>
    </TabView>

  </div>


  <EditPanel :show-enabled="true" v-model="showPanel" :title="formTitle" :form-component="formFileName"
    :form-type="formType" :enum-key="'GlobalAccessControl'" v-model:form="formModel" @save="saveHandler" />
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import FileAccessTable from "@/helpers/pages/GlobalPolicy/FileAccess";
import RegistryAccessTable from "@/helpers/pages/GlobalPolicy/RegistryAccess";
import CodeLoadTable from "@/helpers/pages/GlobalPolicy/CodeLoad";
import AgCard from "@/components/ag-card/index.vue";
import EditPanel from '@/components/ag-edit-panel/index.vue'
import AppGroupForm from '@/components/ag-edit-panel/forms/app-group-form.vue'
import RegistryEditForm from '@/components/ag-edit-panel/forms/registry-edit-form.vue'
import CodeLoadEditForm from '@/components/ag-edit-panel/forms/code-load-edit-form.vue'
import FileAccessEditForm from '@/components/ag-edit-panel/forms/file-access-edit-form.vue'
import Swal from 'sweetalert2';
import { useRoute } from "vue-router";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { useStore } from "@/store";
import TabsFilter from '@/components/ag-tabs-filter/index.vue'
import { useI18n } from 'vue-i18n';

const store = useStore();
const { t } = useI18n();
let fileAccessModule = ref(FileAccessTable)
let registryModule = ref(RegistryAccessTable)
let codeLoadModule = ref(CodeLoadTable)
let formTitle = ref('Edit App Group Information')
let formFileName = ref(AppGroupForm)
const searchQuery = ref('');
const statusFilter = ref([]);
const isMenuOpen = ref(false)
const showPanel = ref(false)
const globalPolicyData = ref({})
const route = useRoute();
const globalPolicyId = computed(() => route.query.id);
const formModel = ref({})
const formType = ref('appGroup');
const tableRowData = ref({})
const activeTab = ref(0);
const registryList = computed(() => store.state.general.globalPolicyRegistryAccess);
const fileAccessList = computed(() => store.state.general.globalPolicyFileAccess);
const codeLoadList = computed(() => store.state.general.globalPolicyCodeLoad);
const templatePolicy = ref(false);
const group = ref(null);
const site = ref({});
const templateId = ref(0);
const currentRole = ref('');
const didOpenFromQuery = ref(false);

watch(activeTab, (newIndex) => {
  searchQuery.value = '';
  fetchForTab(newIndex);
});
function fetchForTab(index) {
  switch (index) {
    case 0:
      if (fileAccessModule.value?.component?.options) {
        fileAccessModule.value.component.options.isLoading = true;
      }
      if (templatePolicy.value) {
        getFileAccessListTemplate();
      } else {
        getFileAccessList();
      }
      break;
    case 1:
      if (registryModule.value?.component?.options) {
        registryModule.value.component.options.isLoading = true;
      }
      if (templatePolicy.value) {
        getRegistryListTemplate();
      } else {
        getRegistryList();
      }
      break;
    case 2:
      if (codeLoadModule.value?.component?.options) {
        codeLoadModule.value.component.options.isLoading = true;
      }
      if (templatePolicy.value) {
        getCodeLoadListTemplate();
      } else {
        getCodeLoadList();
      }
      break;
  }
}

function resolveTabIndexFromQuery() {
  const raw = route.query?.tab;
  if (raw === undefined || raw === null) return null;
  const asNum = Number(raw);
  if (!Number.isNaN(asNum)) return Math.max(0, Math.floor(asNum));
  const key = String(raw).toLowerCase();
  if (key === 'fileaccess') return 0;
  if (key === 'registry') return 1;
  if (key === 'codeload') return 2;
  return null;
}

function setTabFromQuery() {
  const idx = resolveTabIndexFromQuery();
  if (idx !== null) {
    activeTab.value = idx;
  }
}

watch(() => route.query.tab, () => {
  setTabFromQuery();
  fetchForTab(activeTab.value);
});

const useFilteredRows = (rows, searchQuery, statusFilter, getFields) => {
  const query = searchQuery.value.toLowerCase();
  const statusList = statusFilter.value;

  return rows.filter(row => {
    const searchableFields = getFields(row).map(f =>
      (f || "").toLowerCase()
    );

    const matchesSearch =
      !query || searchableFields.some(field => field.includes(query));

    const matchesStatus =
      statusList.length === 0 ||
      (statusList.includes("enabled") && row.enabled === true) ||
      (statusList.includes("disabled") && row.enabled === false);

    return matchesSearch && matchesStatus;
  });
};
const filteredFileAccessRows = computed(() =>
  useFilteredRows(
    fileAccessModule.value.component.options.rows,
    searchQuery,
    statusFilter,
    row => [
      row.folderMapId ? getFolderNameById(row.folderMapId) : "",
      row.fileName ? row.fileName : "",
      row.accessControl ? getAccessControlById(row.accessControl) : ""
    ]
  )
);
const filteredRegistryRows = computed(() =>
  useFilteredRows(
    registryModule.value.component.options.rows,
    searchQuery,
    statusFilter,
    row => [
      row.registryKey ? row.registryKey : "",
      row.registryValue ? row.registryValue : "",
      row.registryHive ? getRegistryHiveById(row.registryHive) : "",
      row.accessControl ? getAccessControlById(row.accessControl) : "",
      row.appliesTo ? getAppliesToById(row.appliesTo) : ""
    ]
  )
);

const filteredCodeLoadRows = computed(() =>
  useFilteredRows(
    codeLoadModule.value.component.options.rows,
    searchQuery,
    statusFilter,
    row => {
      const folderMapName = row.folderMapId ? getFolderNameById(row.folderMapId) : "";
      const fileName = row.fileName ? row.fileName : "";
      const securityAction = row.allowToRun ? "Allow to run" : "Allow to run off";
      return [folderMapName, fileName, securityAction];
    }
  )
);

function getFolderNameById(value) {
  if (value === undefined || value === null) {
    return;
  }
  const folderMaps = store.state.general.folderMaps;
  const folder = folderMaps.find(item => item.value === value);
  return folder ? folder.label : undefined;
}
function getAccessControlById(value) {
  const accessControlOptions = store.state.general.enums['GlobalAccessControl'] || []
  const folder = accessControlOptions.find((item) => item.value === value);
  return folder?.label;
}
function getAppliesToById(value) {
  const appliesToOptions = store.state.general.enums['AppliesTo'] || []
  const option = appliesToOptions.find((item) => item.value === value);
  return option?.label;
}
function getRegistryHiveById(value) {
  const registryHiveOptions = store.state.general.enums['RegistryHive'] || []
  const option = registryHiveOptions.find((item) => item.value === value);
  return option?.label;
}

const saveHandler = async (updatedData) => {
  const group = localStorage.getItem("agms_group");
  const groupId = group ? JSON.parse(group)?.mainid : null;

  if (formType.value === 'fileAccess') {
    fileAccessModule.value.component.options.isLoading = true;
    let body = {
      id: formModel.value.id ? formModel.value.id : 0,
      globalPolicyId: formModel.value.globalPolicyId ? formModel.value.globalPolicyId : globalPolicyData.value.id,
      folderMapId: updatedData.isFolderMapIdAny ? -1 : updatedData.folderMapId,
      fileName: updatedData.fileName,
      accessControl: updatedData.accessControl,
      auditCreateOperations: updatedData.auditCreateOperations,
      enabled: updatedData.enabled,
      groupId: groupId,
      expertNotes: updatedData.expertNotes,
    }
    try {
      let response = null;
      if(templatePolicy.value){
        body.templateId = templateId.value;
        body.globalPolicyId = fileAccessModule.value?.component?.options.rows[0].globalPolicyId;  //todo
        response = await store.dispatch(
          GeneralActionTypes.CREATE_OR_UPDATE_GLOBAL_POLICY_FILE_ACCESS_TEMPLATE,
          body
        );
      }else{
        response = await store.dispatch(
          GeneralActionTypes.CREATE_OR_UPDATE_GLOBAL_POLICY_FILE_ACCESS,
          body
        );
      }
      if (response.isSuccess) {
        showPanel.value = false;
        if(templatePolicy.value){
          getFileAccessListTemplate();
        }else{
          getGlobalPolicyInheritanceInfo();
          getFileAccessList();
        }
        successMessage(body.id);
      }
    } catch (err) {
      fileAccessModule.value.component.options.isLoading = false;
      showError(err);
    }

  }
  else if (formType.value === 'registry') {
    registryModule.value.component.options.isLoading = true;
    let body = {
      id: formModel.value.id ? formModel.value.id : 0,
      globalPolicyId: formModel.value.globalPolicyId ? formModel.value.globalPolicyId : globalPolicyData.value.id,
      registryHive: updatedData.registryHive,
      registryKey: updatedData.registryKey,
      registryValue: updatedData.registryValue,
      accessControl: updatedData.accessControl,
      appliesTo: updatedData.appliesTo,
      enabled: updatedData.enabled,
      groupId: groupId,
      expertNotes: updatedData.expertNotes,
    }
    try {
      let response = null;
      if(templatePolicy.value){
        body.templateId = templateId.value;
        body.globalPolicyId = registryModule.value?.component?.options.rows[0].globalPolicyId;  //todo
        response = await store.dispatch(
          GeneralActionTypes.CREATE_OR_UPDATE_GLOBAL_POLICY_REGISTRY_ACCESS_TEMPLATE,
          body
        );
      }else{
        response = await store.dispatch(
          GeneralActionTypes.CREATE_OR_UPDATE_GLOBAL_POLICY_REGISTRY,
          body
        );
      }
      if (response.isSuccess) {
        showPanel.value = false;
        if(templatePolicy.value){
          getRegistryListTemplate();
        }else{
          getGlobalPolicyInheritanceInfo();
          getRegistryList();
        }
        successMessage(body.id);
      }

    } catch (err) {
      registryModule.value.component.options.isLoading = false;
      showError(err);
    }

  }
  else if (formType.value === 'codeLoad') {
    codeLoadModule.value.component.options.isLoading = true;
    let body = {
      id: formModel.value.id ? formModel.value.id : 0,
      globalPolicyId: formModel.value.globalPolicyId ? formModel.value.globalPolicyId : globalPolicyData.value.id,
      folderMapId: updatedData.isFolderMapIdAny ? -1 : updatedData.folderMapId,
      fileName: updatedData.fileName,
      zoneIdentifier: updatedData.zoneIdentifier ? updatedData.zoneIdentifier : 0,
      allowToRun: updatedData.allowToRun,
      // bAppyToPowerApps: updatedData.bAppyToPowerApps? updatedData.bAppyToPowerApps : false,
      enabled: updatedData.enabled ? updatedData.enabled : false,
      publisherId: updatedData.isPublisherIdAny ? -1 : updatedData.publisherId,
      groupId: groupId,
      expertNotes: updatedData.expertNotes,
    }
    try {
      let response = null;
      if(templatePolicy.value){
        body.templateId = templateId.value;
        body.globalPolicyId = codeLoadModule.value?.component?.options.rows[0].globalPolicyId;  //todo
        response = await store.dispatch(
          GeneralActionTypes.CREATE_OR_UPDATE_GLOBAL_POLICY_CODE_LOAD_TEMPLATE,
          body
        );
      }else{
        response = await store.dispatch(
          GeneralActionTypes.CREATE_OR_UPDATE_GLOBAL_POLICY_CODE_LOAD,
          body
        );
      }
      if (response.isSuccess) {
        showPanel.value = false
        if(templatePolicy.value){
          getCodeLoadListTemplate();
        }else{
          getGlobalPolicyInheritanceInfo();
          getCodeLoadList();
        }
        successMessage(body.id);
      }
    } catch (err) {
      codeLoadModule.value.component.options.isLoading = false;
      showError(err);
    }

  }

}
const successMessage = (id) => {
  if (id === 0) {
    Swal.fire(t('success'), t('ruleAddedSuccessfully'), "success");
  } else {
    Swal.fire(t('success'), t('ruleUpdatedSuccessfully'), "success");
  }
}

// const getGlobalPolicyDetail = async (groupId) => {
//   try {
//     const response = await store.dispatch(GeneralActionTypes.GET_ALL_GLOBAL_POLICY, groupId.value);
//     globalPolicyData.value = response.entityData;
//   } catch (error) {
//     console.error("Global policy detail fetch error:", error);
//   }
// };
const getFolderMaps = async () => {
  await store.dispatch(GeneralActionTypes.GET_FOLDER_MAPS);
}
const getFileAccessList = async () => {
  try {
    await store.dispatch(GeneralActionTypes.GET_GLOBAL_POLICY_FILE_ACCESS)
  } finally {
    fileAccessModule.value.component.options.isLoading = false;
  }
}
const getFileAccessListTemplate = async () => {
  try {
    await store.dispatch(GeneralActionTypes.GET_GLOBAL_POLICY_FILE_ACCESS_TEMPLATE)
  } finally {
    fileAccessModule.value.component.options.isLoading = false;
  }
}

const getRegistryList = async () => {
  try {
    await store.dispatch(GeneralActionTypes.GET_GLOBAL_POLICY_REGISTRY_ACCESS)
  } finally {
    registryModule.value.component.options.isLoading = false;
  }
}
const getRegistryListTemplate = async () => {
  try {
    await store.dispatch(GeneralActionTypes.GET_GLOBAL_POLICY_REGISTRY_ACCESS_TEMPLATE)
  } finally {
    registryModule.value.component.options.isLoading = false;
  }
}

const getCodeLoadList = async () => {
  try {
    await store.dispatch(GeneralActionTypes.GET_GLOBAL_POLICY_CODE_LOAD)
  } finally {
    codeLoadModule.value.component.options.isLoading = false;
  }
}
const getCodeLoadListTemplate = async () => {
  try {
    const response = await store.dispatch(GeneralActionTypes.GET_GLOBAL_POLICY_CODE_LOAD_TEMPLATE);
    const globalPolicyId = response?.entityData?.templatePolicyViewModel?.globalPolicy?.id;
    getPublisherListTemplate(globalPolicyId === 4 ? 5 : globalPolicyId);
  } finally {
    codeLoadModule.value.component.options.isLoading = false;
  }
}

watch(registryList, () => {
  if (registryModule.value?.component?.options) {
    registryModule.value.component.options.rows = registryList.value;
  }
  if (activeTab.value === 1) {
    openEditModalFromQuery (1);
  }
});
watch(fileAccessList, () => {
  if (fileAccessModule.value?.component?.options) {
    fileAccessModule.value.component.options.rows = fileAccessList.value;
  }
  if (activeTab.value === 0) {
    openEditModalFromQuery (0);
  }
});

watch(codeLoadList, () => {
  if (codeLoadModule.value?.component?.options) {
    codeLoadModule.value.component.options.rows = codeLoadList.value;
  }
  if (activeTab.value === 2) {
    openEditModalFromQuery (2);
  }
});

const fetchEnumAndStore = async (name) => {
  await store.dispatch(GeneralActionTypes.GET_ENUM_BY_NAME, name);
};
const getPublisherList = async () => {
  const group = JSON.parse(localStorage.getItem("group"))
  const mainId = group ? group.mainid : 0;
  const response = await store.dispatch(GeneralActionTypes.GET_PUBLISHER_LIST, mainId);
  if (response?.isSuccess && response.entityData) {
    const publisherList = response.entityData.map(publisher => ({
      label: publisher.name,
      value: publisher.id
    }))
    localStorage.setItem("publisherList", JSON.stringify(publisherList));
  }

}
const getPublisherListTemplate = async (id) => {
    await store.dispatch(GeneralActionTypes.GET_TEMPLATE_PUBLISHER_LIST, id);
}

const getGlobalPolicyInheritanceInfo = async () => {
    const mainGroupId = group.value?.mainid ?? JSON.parse(localStorage.getItem("agms_group"))?.mainid ?? 0;
    await store.dispatch(GeneralActionTypes.GET_GLOBAL_POLICY_INHERITANCE_INFO, mainGroupId);
};

function showError(err) {
  const serverData = err?.response?.data ?? err?.data ?? null;
  let msg = "";

  if (serverData?.errors) {
    msg = extractErrorMessage(serverData.errors);
  } else if (serverData?.title) {
    msg = serverData.title;
  } else if (err?.message) {
    msg = err.message;
  } else {
    msg = JSON.stringify(err);
  }

  Swal.fire({
    title: t('error'),
    html: msg || t('unexpectedError'),
    icon: "error"
  });
}
const extractErrorMessage = (errors) => {
  if (!errors) return null;
  if (typeof errors === "string") return errors;
  if (Array.isArray(errors)) return errors.flat().join("<br>");
  if (typeof errors === "object") return Object.values(errors).flat().join("<br>");
  return String(errors);
};

function openEditModalFromQuery (index) {
  if (didOpenFromQuery.value) return;
  const ruleIdRaw = route.query?.ruleId;
  if (ruleIdRaw === undefined || ruleIdRaw === null || ruleIdRaw === '') return;
  const ruleId = Number(ruleIdRaw);
  if (Number.isNaN(ruleId)) return;

  let rows = [];
  if (index === 0) {
    rows = fileAccessModule.value?.component?.options?.rows || [];
  } else if (index === 1) {
    rows = registryModule.value?.component?.options?.rows || [];
  } else if (index === 2) {
    rows = codeLoadModule.value?.component?.options?.rows || [];
  }
  if (!rows || rows.length === 0) return;

  const row = rows.find(r => r && (r.id === ruleId));
  if (!row) return;

  if (index === 0) {
    editFunction2(t('editRule'), FileAccessEditForm, 'fileAccess', row);
  } else if (index === 1) {
    editFunction2(t('editRule'), RegistryEditForm, 'registry', row);
  } else if (index === 2) {
    editFunction2(t('editRule'), CodeLoadEditForm, 'codeLoad', row);
  }
  didOpenFromQuery.value = true;
}

onMounted(() => {
  try {
    store.dispatch(GeneralActionTypes.LOADER_STATUS, false);
    document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
    document.body.classList.remove('modal-open');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('paddingRight');
  } catch (e) { /* noop */ }

  const templateStr = localStorage.getItem("agms_template");
  const mainId = templateStr ? JSON.parse(templateStr)?.mainid : null;
  templateId.value = mainId;
  currentRole.value = templateStr ? JSON.parse(templateStr)?.template : null;
  const routeName = useRoute().name;
  if (routeName == 'templateGlobalPolicy') {
    templatePolicy.value = true;
  } else {
    templatePolicy.value = false;
    getPublisherList();
    getGlobalPolicyInheritanceInfo();
  }
  
  group.value = JSON.parse(localStorage.getItem("agms_group")) || {};
  site.value = JSON.parse(localStorage.getItem("agms_site")) || {};
  getFolderMaps();
  setTabFromQuery();
  fetchForTab(activeTab.value);
  openEditModalFromQuery (activeTab.value);
  fetchEnumAndStore("RegistryHive");
  fetchEnumAndStore("GlobalAccessControl");
  fetchEnumAndStore("AppliesTo");
  fetchEnumAndStore("ZoneIdentifier");
  
});

function showEdit(title, formName, type, data = {}) {
  formModel.value = { ...data }
  formTitle.value = title;
  formFileName.value = formName;
  showPanel.value = true;
  formType.value = type;
}

const menu = ref()

const isLinked = computed(() => {
  return store.state.general.inheritanceInfo?.isInherited
})
const isTemplateDefault = computed(() => {
  return store.state.general.isTemplateDefault
})
const isTemplatePolicyDefault = computed(() => {
  return store.state.general.isTemplatePolicyDefault
})
const items = computed(() => [
  { label: t('resetToDefault'), command: () => doAction('reset'), disabled: (!templatePolicy.value && isLinked.value ) || (templatePolicy.value && isTemplateDefault.value === false) || (isTemplatePolicyDefault.value === true)},
])


const doAction = async (action) => {
  if (action === 'reset') {
    const result = await Swal.fire({
      title: t('resetToDefault'),
      icon: "warning",
      text: t('resetToDefaultConfirmMessage'),
      showCancelButton: true,
      confirmButtonText: t('resetToDefault'),
      cancelButtonText: t('cancel'),
      reverseButtons: true,
      didOpen: () => {
        const btn = Swal.getConfirmButton();
        if (btn) {
          btn.innerHTML = `<i class="pi pi-refresh" style="margin-right:8px"></i><span>${t('resetToDefault')}</span>`;
        }
      },

    });
    if (result.isConfirmed) {
      resetToDefault()
    }
  }
}
async function resetToDefault() {
    try {
        if (templatePolicy.value) {
            await store.dispatch(
                GeneralActionTypes.TEMPLATE_RESET_TO_DEFAULT_GLOBAL_POLICY,
                templateId.value
            );
            await getFileAccessListTemplate();
            await getRegistryListTemplate();
            await getCodeLoadListTemplate();
        } else {
            const group = localStorage.getItem("agms_group");
            const groupId = group ? JSON.parse(group)?.mainid : null;
            await store.dispatch(
                GeneralActionTypes.RESET_TO_DEFAULT_GLOBAL_POLICY,
                groupId
            );
            await getGlobalPolicyInheritanceInfo();
            await getFileAccessList();
            await getRegistryList();
            await getCodeLoadList();
        }
        Swal.fire(t('success'), t('globalPolicyResetSuccessfully'), "success");
    } catch (err) {
        showError(err);
    }
}

function clearSearch() {
  searchQuery.value = '';
  statusFilter.value = [];
}

function editFunction2(title, formName, formType, rowData) {
  tableRowData.value = rowData;
  showEdit(title, formName, formType, rowData)
}

async function deleteGlobalPolicy(rowData, type) {
  let apiMethod = null;
  if (type === 'fileAccess') {
    if(templatePolicy.value){
        rowData.templateId = templateId.value;
        apiMethod = GeneralActionTypes.DELETE_GLOBAL_POLICY_FILE_ACCESS_TEMPLATE;
    }else{
        apiMethod = GeneralActionTypes.DELETE_GLOBAL_POLICY_FILE_ACCESS;
    }
  }
  else if (type === 'registry') {
    if(templatePolicy.value){
        rowData.templateId = templateId.value;
        apiMethod = GeneralActionTypes.DELETE_GLOBAL_POLICY_REGISTRY_ACCESS_TEMPLATE;
    }else{
        apiMethod = GeneralActionTypes.DELETE_GLOBAL_POLICY_REGISTRY;
    }
  }
  else if (type === 'codeLoad') {
    if(templatePolicy.value){
        rowData.templateId = templateId.value;
        apiMethod = GeneralActionTypes.DELETE_GLOBAL_POLICY_CODE_LOAD_TEMPLATE;
    }else{
        apiMethod = GeneralActionTypes.DELETE_GLOBAL_POLICY_CODE_LOAD;
    }
  }
  const result = await Swal.fire({
    title: t('areYouSure'),
    icon: "warning",
    text: t('youAreAboutToDeleteSelectedItem'),
    showCancelButton: true,
    confirmButtonText: t('delete'),
    cancelButtonText: t('cancel'),
  });
  if (result.isConfirmed) {
    try {
      const responseApi = templatePolicy.value ? await store.dispatch(apiMethod, rowData) : await store.dispatch(apiMethod, rowData.id);
      if (responseApi.isSuccess) {
        Swal.fire(t('deleted'), t('globalPolicyDeletedSuccessfully'), "success");
        getGlobalPolicyInheritanceInfo();
        if (type === 'fileAccess') {
          if(templatePolicy.value){
            getFileAccessListTemplate();
          }else{
            getFileAccessList();
          }
        }
        else if (type === 'registry') {
          if(templatePolicy.value){
            getRegistryListTemplate();
          }else{
            getRegistryList();
          }
        }
        else if (type === 'codeLoad') {
          if(templatePolicy.value){
            getCodeLoadListTemplate();
          }else{
            getCodeLoadList();
          }
        }
      } else {
        Swal.fire(t('error'), responseApi.data?.message || t('deleteFailed'), "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire(t('error'), t('deleteError'), "error");
    }
  }
};
async function copyFunction(rowData, type) {
  const copyData = { ...rowData, id: 0, enabled: false }
  if (type === 'fileAccess') {
    editFunction2(t('addRule'), FileAccessEditForm, 'fileAccess', copyData)
  }
  else if (type === 'registry') {
    editFunction2(t('addRule'), RegistryEditForm, 'registry', copyData)
  }
  else if (type === 'codeLoad') {
    editFunction2(t('addRule'), CodeLoadEditForm, 'codeLoad', copyData)
  }
}

</script>


<style >
.btn-primary {
  background-color: #0b4c8c;
  border-color: #0b4c8c;
}

.btn-primary .pi {
  margin-left: 0.5rem;
}

.custom-tabs .p-tabview-nav {
  border-bottom: none !important;
  justify-content: start;
  gap: 5rem;
  background-color: transparent !important;
  padding-left: 1rem;
}

.custom-tabs .p-tabview-nav li .p-tabview-nav-link {
  color: #898C90 !important;
  font-weight: bold;
  border: none;
  border-radius: 0;
  background: transparent;
  font-size: 1.1rem;
  padding: 0.75rem 0;
  transition: color 0.2s ease;
}

.custom-tabs .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  color: #0055A6 !important;
  border-bottom: 2px solid #0055A6;
  background: transparent;
}

.custom-tabs .p-tabview-nav li .p-tabview-nav-link:hover {
  color: #0055A6;
  background: transparent;
}

.custom-icon-button {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: transparent;
  border: none;
  box-shadow: none;
  color: #2c5f89;
  font-weight: bold;
  text-transform: uppercase;
  padding: 0;
  font-size: 0.8rem;
}

.custom-icon-button:hover {
  opacity: 0.8;
  cursor: pointer;
}

.icon-circle {
  background-color: #2c5f89;
  color: white;
  border-radius: 50%;
  padding: 8px;
  font-size: 0.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.detail-edit-icon {
  width: 20px;
  height: 20px;
}

.search-wrapper {
  position: relative;
}

.search-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
}

.top-div {
  background-color: #fff;
  margin-left: -25px;
  margin-right: -15px;
  margin-top: -23px;
  margin-bottom: 40px;
  padding:30px 20px;
}

.text-muted {
  margin-top: 10px;
  color: #01172F !important;
  font-size: 0.8em;
  padding-left: 0;
}

.p-tabview .p-tabview-panels {
  background-color: transparent;
}

.table-border-div {
  border-top: 1px solid #D2D9E2;
  border-left: 1px solid #D2D9E2;
  border-right: 1px solid #D2D9E2;
  padding-top: 30px;
}

.actions-btn {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background-color: #0C4F93;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  min-width: 12.5rem;
}

.actions-btn .label {
  font-size: 0.95rem;
}

.actions-btn .divider {
  width: 1px;
  height: 18px;
  background: rgba(255, 255, 255, 0.6);
  margin-left: auto;
}

.actions-btn .chevron {
  color: #ffffff;
  font-size: 0.9rem;
}

.actions-btn:hover {
  opacity: 0.95;
}

.p-menu {
  border: 1px solid #D2D9E2 !important;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12) !important;
  border-radius: 10px !important;
  overflow: hidden;
}

.p-menu .p-menuitem-link {
  padding: 0.75rem 1rem !important;
  color: #0B1736 !important;
  font-weight: 600;
}

.p-menu .p-menuitem-link .p-menuitem-icon {
  margin-right: 0.5rem;
}

.p-menu .text-danger {
  color: #C62828 !important;
}

.label-text {
  color: #3C73AA;
}
</style>
